(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["form-toast"] && !Shopify.designMode) return;
  try {
    (function () {
    // Single-use marker recording which form the visitor last submitted.
    // Read and cleared once per page load (before the per-toast loop below)
    // so it can't leak into an unrelated later success or get consumed by
    // the wrong toast.
    var pendingKey = 'formToastPending';
    var pendingValue = null;
    try {
      pendingValue = window.sessionStorage.getItem(pendingKey);
      window.sessionStorage.removeItem(pendingKey);
    } catch (e) {}

    document.querySelectorAll('[data-form-toast]').forEach(function (toast) {
      // Escapes the stacking context that the parallax script (see
      // slide-sections.liquid) applies to each section wrapper, which would
      // otherwise trap this fixed-position toast behind later sections.
      document.body.appendChild(toast);

      var closeBtn = toast.querySelector('[data-form-toast-close]');
      var successParam = toast.dataset.successParam;
      var hideTimer = null;

      function hide() {
        window.clearTimeout(hideTimer);
        toast.classList.remove('is-visible');
        toast.setAttribute('aria-hidden', 'true');
      }

      function show() {
        toast.classList.add('is-visible');
        toast.setAttribute('aria-hidden', 'false');
        toast.focus();
        hideTimer = window.setTimeout(hide, 6000);
      }

      var form = toast.dataset.formId && document.getElementById(toast.dataset.formId);
      if (form && successParam) {
        form.addEventListener('submit', function () {
          try { window.sessionStorage.setItem(pendingKey, successParam); } catch (e) {}
        });
      }

      var url = new URL(window.location.href);
      var queryMatch = successParam && url.searchParams.get(successParam) === 'true';
      var flagMatch = toast.dataset.postedSuccessfully === 'true' && pendingValue === successParam;

      if (queryMatch || flagMatch) {
        show();

        // Strip our marker (and Shopify's own flag) so a later reload of
        // this same URL doesn't show the toast again.
        url.searchParams.delete(successParam);
        url.searchParams.delete('contact_posted_successfully');
        window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
      }

      if (closeBtn) closeBtn.addEventListener('click', hide);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["slide-sections"] && !Shopify.designMode) return;
  try {
    (function () {
  // All content sections (header/footer groups excluded)
  var allSections = Array.from(
    document.querySelectorAll('.shopify-section')
  ).filter(function (el) {
    return !el.closest('.shopify-section-group')
        && !el.querySelector('.site-header')
        && !el.querySelector('.site-footer');
  });

  // Parallax-eligible subset (excludes data-no-parallax sections)
  var sections = allSections.filter(function (el) {
    return !el.querySelector('[data-no-parallax]');
  });

  if (!allSections.length) return;

  // Activate CSS stacking rules
  document.body.classList.add('js-parallax');

  // Every section gets an increasing z-index so later sections slide over earlier ones.
  // Non-parallax sections (e.g. choose-path) get position:relative so z-index takes effect.
  allSections.forEach(function (section, i) {
    section.style.zIndex = i + 1;
    if (section.querySelector('[data-no-parallax]')) {
      section.style.position = 'relative';
    }
  });

  // Collect sections that have a parallax background, a fadeable content, or both
  var parallaxItems = sections
    .map(function (section) {
      return {
        el:      section,
        bg:      section.querySelector('.hero-city__bg'),
        content: section.querySelector('.hero-city__content')
      };
    })
    .filter(function (item) { return item.bg !== null || item.content !== null; });

  // Returns the element's natural top position regardless of sticky offset
  function naturalTop(el) {
    var top = 0;
    var node = el;
    while (node) {
      top += node.offsetTop;
      node = node.offsetParent;
    }
    return top;
  }

  // --- Hex nav ---
  // Uses IntersectionObserver instead of scroll-position math: it fires the
  // same way regardless of scroll direction, so it stays correct whether the
  // visitor scrolls down through the hero stack or back up from the footer.
  var navItems = parallaxItems.filter(function (item) {
    return item.content && item.content.querySelector('.city-name');
  });

  if (navItems.length) {
    var nav = document.createElement('nav');
    nav.className = 'hex-nav';
    nav.setAttribute('aria-label', 'City sections');

    var navDots = navItems.map(function (item) {
      var cityEl = item.content.querySelector('.city-name');
      var label  = cityEl ? cityEl.textContent.trim() : '';

      var btn = document.createElement('button');
      btn.className = 'hex-nav__dot';
      btn.type = 'button';
      btn.setAttribute('aria-label', label);

      var inner = document.createElement('span');
      inner.className = 'hex-nav__dot-inner';
      btn.appendChild(inner);

      if (label) {
        var lbl = document.createElement('span');
        lbl.className = 'hex-nav__label';
        lbl.textContent = label;
        btn.appendChild(lbl);
      }

      btn.addEventListener('click', function () {
        item.el.scrollIntoView({ behavior: 'smooth' });
      });

      nav.appendChild(btn);
      return { btn: btn, el: item.el, visible: false };
    });

    document.body.appendChild(nav);

    // On mobile, the hex nav should also fade out once the visitor reaches
    // the "Nuestro enfoque" (positioning) section, regardless of whether a
    // hero dot is technically still intersecting the viewport. This is sticky:
    // once reached, the nav stays hidden all the way to the footer, even if
    // the visitor scrolls back up past the section afterwards.
    var focusSection = document.querySelector('#para-quien');
    var reachedFocusSection = false;
    var mobileQuery = window.matchMedia('(max-width: 640px)');

    function updateNavVisibility() {
      // Sections stack with increasing z-index, so when more than one is
      // technically visible at once, the last one in document order is the
      // one actually on top — that's the active dot.
      var visibleDots = navDots.filter(function (d) { return d.visible; });
      var active = visibleDots[visibleDots.length - 1];

      navDots.forEach(function (d) {
        d.btn.classList.toggle('is-active', d === active);
      });

      var shouldHide = visibleDots.length === 0 || (mobileQuery.matches && reachedFocusSection);
      nav.classList.toggle('hex-nav--hidden', shouldHide);
    }

    var navObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var dot = navDots.find(function (d) { return d.el === entry.target; });
        if (dot) dot.visible = entry.intersectionRatio >= 0.5;
      });
      updateNavVisibility();
    }, { threshold: [0, 0.5] });

    navDots.forEach(function (dot) { navObserver.observe(dot.el); });

    if (focusSection) {
      var focusObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) reachedFocusSection = true;
        });
        updateNavVisibility();
      }, { threshold: 0 });

      focusObserver.observe(focusSection);
    }
  }
  // --- End hex nav ---

  function tick() {
    var scrollY = window.scrollY;
    var vh = window.innerHeight;

    parallaxItems.forEach(function (item) {
      var sectionTop = naturalTop(item.el);

      /*
       * progress = 0   → section entering from below
       * progress = 0.5 → section fully in view (stuck at top)
       * progress = 1   → section fully covered by next section
       */
      var progress = (scrollY - sectionTop + vh) / (vh * 2);
      progress = Math.max(0, Math.min(1, progress));

      // Background: moves at ~50% scroll speed (±15% travel)
      if (item.bg) {
        var bgOffset = (0.5 - progress) * 30;
        item.bg.style.transform = 'translateY(' + bgOffset + '%)';
      }

      // Content fade-out upward.
      // .intro-hero__content and .hero-city__content each have their own dedicated
      // listener, so skip them here to avoid conflicting animations.
      if (item.content
          && !item.content.classList.contains('intro-hero__content')
          && !item.content.classList.contains('hero-city__content')) {
        var fadeStart = 0.54;
        var fadeEnd   = 0.88;
        var maxLift   = 48;
        var t = Math.max(0, Math.min(1, (progress - fadeStart) / (fadeEnd - fadeStart)));
        item.content.style.opacity   = 1 - t;
        item.content.style.transform = 'translateY(' + (-t * maxLift) + 'px)';
      }
    });
  }

  window.addEventListener('scroll', function () {
    requestAnimationFrame(tick);
  }, { passive: true });

  // Recalculate parallax offsets on resize (natural tops may shift).
  // The hex nav needs no manual recalculation: IntersectionObserver already
  // re-evaluates automatically when the viewport size changes.
  window.addEventListener('resize', function () {
    requestAnimationFrame(tick);
  });

  tick();
})();
  } catch(e) { console.error(e); }
})();

})();
